<template>
    <tr>
        <td v-for="(column, columnKey) in columns" :key="'cell-loader-' + columnKey">
            <skeleton width="100%" rounded/>
        </td>
    </tr>
</template>

<script>
export default {
        name: 'TableLoadingRow',

        props: {
            // The amount of columns to show cell loaders for
            columns: {
                type: Number,
                required: true
            },
        },
    }
</script>